import React from "react";
import config from "../../config";
import Link from "next/link";

interface UpgradeToastProps {
  message?: string;
  upgradeUrl?: string;
}

const UpgradeToast: React.FC<UpgradeToastProps> = ({
  message = config.FREE_PLAN_MESSAGE,
  upgradeUrl = "/settings?tab=billing",
}) => {
  return (
    <div>
      <span>{message}</span>
      <Link href={upgradeUrl}>
        <span className="ml-2 cursor-pointer font-semibold underline">
          Upgrade
        </span>
      </Link>
    </div>
  );
};

export default UpgradeToast;
